'use strict'

{omitUndefined} = require '../../../page/helpers/underscore_replacement'

DEFAULT_MAX_PAGINATION_SLOTS_PER_PAGE = 10
TERMINATOR_AND_DOTS = 2
CURRENT_PAGE_NUMBER_WITH_BOX = 1
LAST_INDEX_OF_CONSTANT_ITEMS = 2
MIN_PAGE_SLOTS = 5

module.exports =
  toArray: ({ currentPageNumber, totalPages, getPageUrl, maxPaginationSlotsPerPage, useExpandingPagination}) ->
    maxPaginationSlotsPerPage ?= DEFAULT_MAX_PAGINATION_SLOTS_PER_PAGE
    currentPageNumber = parseInt currentPageNumber
    endDotsThreshold = maxPaginationSlotsPerPage - TERMINATOR_AND_DOTS
    startDotsThreshold = totalPages - maxPaginationSlotsPerPage + TERMINATOR_AND_DOTS + 1

    if totalPages <= maxPaginationSlotsPerPage
      pages = getPagesByRange 1, totalPages, currentPageNumber, getPageUrl

      if totalPages > MIN_PAGE_SLOTS
        pages.splice(3, 0, {
          text: '...'
          selected: false
          isEllipsis: true
        })

        pages.forEach (page, index) ->
          if LAST_INDEX_OF_CONSTANT_ITEMS < index < (pages.length - 1)
            page.respond = true

      pages

    else if currentPageNumber < endDotsThreshold

      if useExpandingPagination
        minPage = 3
        if currentPageNumber >= minPage
          minimumShownPage = currentPageNumber + 1
        else
          minimumShownPage = minPage
        pages = getPagesByRange(1, minimumShownPage, currentPageNumber, getPageUrl)

      else
        pages = getPagesByRange(1, endDotsThreshold, currentPageNumber, getPageUrl)

      pages.forEach (page, index) ->
        page.respond = true if index > 2

      [
        pages...
        getDotsAndLastPage(currentPageNumber, totalPages, getPageUrl)...
      ]

    else if currentPageNumber > startDotsThreshold
      pages = getPagesByRange(startDotsThreshold, totalPages, currentPageNumber, getPageUrl)
      pages.forEach (page, index) ->
        page.respond = true if index < (pages.length - 3)

      [
        getFirstPageAndDots(currentPageNumber, getPageUrl)...
        pages...
      ]

    else
      numbersRadius = (maxPaginationSlotsPerPage - (TERMINATOR_AND_DOTS * 2) - CURRENT_PAGE_NUMBER_WITH_BOX) / 2
      startNumber = currentPageNumber - Math.floor(numbersRadius)
      endNumber = currentPageNumber + Math.ceil(numbersRadius)

      pages = getPagesByRange(startNumber, endNumber, currentPageNumber, getPageUrl)
      pages.forEach (page, index) ->
        page.respond = true unless page.selected

      [
        getFirstPageAndDots(currentPageNumber, getPageUrl)...
        pages...
        getDotsAndLastPage(currentPageNumber, totalPages, getPageUrl)...
      ]

getFirstPageAndDots = (currentPageNumber, getPageUrl) ->
  [
    getPageHash 1, currentPageNumber, getPageUrl
    {
      text: '...'
      selected: false
      isEllipsis: true
    }
  ]

getDotsAndLastPage = (currentPageNumber, totalPages, getPageUrl) ->
  [
    {
      text: '...'
      selected: false
      isEllipsis: true
    }
    getPageHash totalPages, currentPageNumber, getPageUrl
  ]

getPagesByRange = (from, to, currentPageNumber, getPageUrl) ->
  getPageHash pageNumber, currentPageNumber, getPageUrl for pageNumber in [from..to] by 1

getPageHash = (pageNumber, currentPageNumber, getPageUrl) ->
  isCurrentPage = pageNumber is currentPageNumber

  omitUndefined {
    selected: isCurrentPage
    text: pageNumber
    url: getPageUrl(pageNumber) unless isCurrentPage
  }
